import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';
import { withStyles } from '@material-ui/styles';

const styles = () => ({
  icon: {
    width: 107,
    height: 105,
  },
});

type SupportIconProps = {
  classes: any;
};

const SupportIconCore = (props: SupportIconProps) => {
  const { classes } = props;

  return (
    <SvgIcon
      fontSize="inherit"
      viewBox="0 0 107 105"
      classes={{ root: classes.icon }}
    >
      <g id="-" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          id="SSO-Login-Announcement-block-is-hidden"
          transform="translate(-1126.000000, -45.000000)"
        >
          <g id="phone-receiver" transform="translate(1127.000000, 45.000000)">
            <g id="Group-2" transform="translate(0.000000, 0.500000)">
              <path
                d="M63.9895137,57.8622581 C64.0361315,58.2196402 63.9272933,58.5303741 63.6634556,58.7944599 L60.5659037,61.8706115 C60.4261645,62.0259784 60.2437653,62.1581546 60.0186299,62.2667972 C59.7934945,62.3755922 59.5722789,62.4455073 59.3549829,62.4765426 C59.3394563,62.4765426 59.2927625,62.480541 59.2150915,62.4883094 C59.1375728,62.4960397 59.0366501,62.5 58.9124374,62.5 C58.6173564,62.5 58.1398761,62.4495057 57.4799966,62.3484791 C56.8201171,62.2474525 56.0127732,61.9988273 55.0579649,61.6027177 C54.1029282,61.206532 53.0199876,60.6121772 51.8089527,59.8198818 C50.5979178,59.0276245 49.3091739,57.9399796 47.9428351,56.5571756 C46.8559748,55.4851436 45.9554334,54.4597216 45.2412109,53.4809478 C44.5269884,52.5020979 43.952505,51.5970853 43.5177609,50.7658721 C43.0829787,49.9346588 42.7569206,49.181129 42.5395485,48.5052828 C42.3221765,47.8294365 42.174674,47.2468104 42.0970411,46.7574044 C42.0194082,46.2679985 41.9883551,45.8834653 42.0038816,45.6038047 C42.0194082,45.3241442 42.0271715,45.1687772 42.0271715,45.1377038 C42.0582247,44.9201901 42.1280943,44.6987922 42.2367803,44.4735101 C42.3454663,44.248228 42.4774422,44.0656718 42.632708,43.9258415 L45.73026,40.8262706 C45.947632,40.6087569 46.1960573,40.5 46.4755356,40.5 C46.6773811,40.5 46.8559367,40.5582626 47.0112025,40.6747878 C47.1664683,40.7913131 47.2984442,40.9350275 47.4071302,41.1059312 L49.8991457,45.8368552 C50.0388849,46.0854423 50.0777013,46.3573345 50.015595,46.6525317 C49.9534887,46.947729 49.8215128,47.1963161 49.6196673,47.3982931 L48.478464,48.5402403 C48.4474108,48.5713137 48.4202393,48.621808 48.3969495,48.6917231 C48.3736596,48.7616382 48.3620147,48.8199009 48.3620147,48.8665109 C48.424121,49.1927816 48.5638601,49.5656623 48.7812322,49.9851531 C48.9675511,50.3580338 49.2547928,50.8124821 49.6429572,51.3484982 C50.0311216,51.8845142 50.5823151,52.5020598 51.2965376,53.2012111 C51.9952335,53.9159753 52.6162966,54.471336 53.1597267,54.867598 C53.7030427,55.2636314 54.1573473,55.5550587 54.5222219,55.741499 C54.8870964,55.9279394 55.1665748,56.0405804 55.3606189,56.0793079 L55.6516661,56.1376086 C55.6827193,56.1376086 55.7332948,56.125918 55.8030883,56.1026511 C55.8729579,56.0793079 55.9234193,56.0521568 55.9545105,56.0210453 L57.2819947,54.6693528 C57.5616253,54.4208037 57.8875312,54.2965101 58.2602071,54.2965101 C58.524235,54.2965101 58.7337296,54.3430821 58.8889954,54.4363404 L58.9122472,54.4363404 L63.407153,57.0931155 C63.7333252,57.2952448 63.9273694,57.5515242 63.9895137,57.8622581 Z"
                id="Path"
                fill="#FFFFFF"
                fillRule="nonzero"
              />
              <ellipse
                id="Oval-Copy-2"
                strokeOpacity="0.05"
                stroke="#FFFFFF"
                cx="52.5"
                cy="52"
                rx="52.5"
                ry="52"
              />
              <ellipse
                id="Oval-Copy-3"
                strokeOpacity="0.15"
                stroke="#FFFFFF"
                cx="52.5"
                cy="52"
                rx="38.5"
                ry="38"
              />
              <ellipse
                id="Oval-Copy-4"
                strokeOpacity="0.300262238"
                stroke="#FFFFFF"
                cx="52.5"
                cy="52"
                rx="25.5"
                ry="25"
              />
            </g>
          </g>
        </g>
      </g>
    </SvgIcon>
  );
};

export const SupportIcon = withStyles(styles)(SupportIconCore);
